import { adminApiService } from './adminApiService';
import { database } from '../../firebase';
import { ref, update } from 'firebase/database';

// Check if email API is configured (based on admin authentication)
export const isEmailAPIConfigured = () => {
  return adminApiService.hasValidSession();
};

// Send invitation emails using the staging API
export const sendInvitationEmail = async (emailData) => {
  try {
    if (!adminApiService.hasValidSession()) {
      throw new Error('Admin authentication required');
    }

    const { recipients, subject, content, playStoreLink, appStoreLink } = emailData;

    // Prepare the request body according to API specification
    const requestBody = {
      email_list: recipients,
      subject: subject,
      mail_body: content,
      android_link: playStoreLink || '',
      ios_link: appStoreLink || ''
    };

    // Make the API call to send emails
    const response = await adminApiService.makeAuthenticatedRequest(
      '/api/v1/send_invitation',
      'POST',
      requestBody
    );

    if (response.success) {
      return {
        success: true,
        data: response.data,
        sentTo: recipients.length
      };
    } else {
      throw new Error(response.error || 'Failed to send emails');
    }
  } catch (error) {
    console.error('Send invitation email error:', error);
    return {
      success: false,
      error: error.message || 'Failed to send invitation emails'
    };
  }
};

// Update wishlist entries to mark emails as sent
export const markEmailsSent = async (wishlistEntries, emailData) => {
  try {
    const updates = {};
    const currentTime = new Date().toISOString();

    // Create update object for each wishlist entry
    wishlistEntries.forEach(entry => {
      updates[`wishlist/${entry.id}/emailSent`] = true;
      updates[`wishlist/${entry.id}/emailSentAt`] = currentTime;
      updates[`wishlist/${entry.id}/emailSubject`] = emailData.subject;
      updates[`wishlist/${entry.id}/lastEmailCampaign`] = {
        sentAt: currentTime,
        subject: emailData.subject,
        hasAppLinks: !!(emailData.playStoreLink || emailData.appStoreLink)
      };
    });

    // Perform batch update to Firebase
    await update(ref(database), updates);

    return {
      success: true,
      updated: wishlistEntries.length
    };
  } catch (error) {
    console.error('Error marking emails as sent:', error);
    return {
      success: false,
      error: error.message || 'Failed to update wishlist entries'
    };
  }
};

// Send test email using the API
export const sendTestEmail = async (email) => {
  try {
    if (!adminApiService.hasValidSession()) {
      throw new Error('Admin authentication required');
    }

    const requestBody = {
      email_list: [email],
      subject: 'Test Email from Memic Admin',
      mail_body: 'This is a test email to verify the email configuration is working correctly.',
      android_link: '',
      ios_link: ''
    };

    const response = await adminApiService.makeAuthenticatedRequest(
      '/api/v1/send_invitation',
      'POST',
      requestBody
    );

    if (response.success) {
      return {
        success: true,
        data: response.data,
        message: 'Test email sent successfully'
      };
    } else {
      throw new Error(response.error || 'Failed to send test email');
    }
  } catch (error) {
    console.error('Send test email error:', error);
    return {
      success: false,
      error: error.message || 'Failed to send test email'
    };
  }
};

// Send email to specific recipients
export const sendEmail = async (emailData) => {
  try {
    const result = await sendInvitationEmail(emailData);
    return result;
  } catch (error) {
    console.error('Send email error:', error);
    return {
      success: false,
      error: error.message || 'Failed to send email'
    };
  }
};

// Fetch API key status (check if admin is authenticated)
export const fetchApiKeyFromFirebase = async () => {
  try {
    return adminApiService.hasValidSession();
  } catch (error) {
    console.error('Error checking API key status:', error);
    return false;
  }
}; 